export const COMPANY_MOVE_RESPONSIBLE = 'CompanyMoveResponsible';
export const DISTRUBUTOR_ADMINISTRATOR = 'Distributor administrator'; 